// TODO: Migrate to PetitionQRCodeDownload from 'src/app/shared/components/qrcode'
import { QRCodeDownload as QRCodeDownloadSunrise } from './components/QRCodeDownload';
import { usePetitionUrlQRCode } from './hooks/usePetitionUrlQRCode';

export function PetitionUrlQRCode() {
	const { data, actions } = usePetitionUrlQRCode();

	return (
		<div className="mt-6">
			<QRCodeDownloadSunrise
				slugOrId={data.slugOrId}
				displaySize={data.displaySize}
				displayType={data.displayType}
				downloadType={data.downloadType}
				descriptionText={data.descriptionText}
				downloadLinkText={data.downloadLinkText}
				downloadFilename={data.downloadFilename}
				onDownload={actions.handleDownload}
			/>
		</div>
	);
}
